module.exports = __webpack_public_path__ + "img/heading.82ac6079.svg";